import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { ImageRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";

type Props = {
  fragment: ImageRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function ImageRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "image",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("ImageRegionTypeCard.title")}
      description={t("ImageRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
